module.exports = __webpack_public_path__ + "media/images/landing-pages/lp-pri-crs-3-99946dbef710697f74058f3659cf62ed.png";